import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Employer } from '../../employers/employer.interface';
import { EmployerService } from './employer.service';

const service = new EmployerService();

export interface EmployerState {
   employersOverview?: ApiResource<Array<Employer>>;
}

const EmployerStore: Module<EmployerState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_EMPLOYERS(state, overview: ApiResource<Array<Employer>>) {
         state.employersOverview = overview;
      },
      ADD_EMPLOYER(state, employer: Employer) {
         state.employersOverview?.data?.push(employer);
      },
      CHANGE_EMPLOYER(state, employer: Employer) {
         const index = (state.employersOverview?.data || []).findIndex((e) => e.id === employer.id);
         if (index > -1) state.employersOverview?.data.splice(index, 1, employer);
      },
      DELETE_EMPLOYER(state, employerId: number) {
         const index = (state.employersOverview?.data || []).findIndex((e) => e.id === employerId);
         if (index > -1) state.employersOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getEmployers(context, payload: { tenantId: number; query?: LocationQuery }) {
         const response = await service.getEmployers(payload.tenantId, payload.query);
         context.commit('SET_EMPLOYERS', response);
         return response;
      },
      async getEmployer(context, payload: { tenantId: number; employerId: number }) {
         return await service.getEmployer(payload.tenantId, payload.employerId);
      },
      async createEmployer(context, payload: { tenantId: number; employer: Employer }) {
         let response = await service.postEmployer(payload.tenantId, payload.employer);
         if (typeof payload.employer.logo === 'object') {
            response = await context.dispatch('changeEmployerLogo', {
               tenantId: payload.tenantId,
               employerId: response.id,
               logo: payload.employer.logo,
            });
         }
         context.commit('ADD_EMPLOYER', response);
         return response;
      },
      async changeEmployer(context, payload: { tenantId: number; employerId: number; employer: Employer }) {
         let response = await service.putEmployer(payload.tenantId, payload.employerId, payload.employer);

         if (typeof payload.employer.logo === 'object') {
            response = await context.dispatch('changeEmployerLogo', {
               tenantId: payload.tenantId,
               employerId: response.id,
               logo: payload.employer.logo,
            });
         }
         context.commit('CHANGE_EMPLOYER', response);
         return response;
      },
      async deleteEmployer(context, payload: { tenantId: number; employerId: number }) {
         const response = await service.deleteEmployer(payload.tenantId, payload.employerId);
         context.commit('DELETE_EMPLOYER', response);
         return response;
      },

      async changeEmployerLogo(context, payload: { tenantId: number; employerId: number; logo: File }) {
         return service.postEmployerLogo(payload.tenantId, payload.employerId, payload.logo);
      },
   },
};

export default EmployerStore;
